import React from 'react'

const Footer = () => {
  return (
    <footer className='footer'>
      © filtry 2023. Developed by srijan :)
    </footer>
  )
}

export default Footer
